import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Instagram } from 'lucide-react';
interface SponsorsSectionProps {
  variant?: 'compact' | 'full';
}
const sponsors = [{
  name: 'Dra. Ysailis Martínez',
  role: 'Obstetricia & Ginecología',
  instagram: '@draysailismartinez',
  instagramUrl: 'https://instagram.com/draysailismartinez',
  logo: 'https://cdn.magicpatterns.com/uploads/1rdJXsAJnXrzbeZBh9qrXC/logo_Dra_Ysalismar.png'
}, {
  name: 'Centro Médico Especializado Profem',
  role: 'Centro Médico Especializado',
  instagram: '@profemm.ccs',
  instagramUrl: 'https://instagram.com/profemm.ccs',
  logo: 'https://cdn.magicpatterns.com/uploads/b5xQGXCQZEXAJVaqQvuMSt/Logo_Centro_medico_Especializado_Profem.jpg'
}];
export function SponsorsSection({
  variant = 'full'
}: SponsorsSectionProps) {
  const isCompact = variant === 'compact';
  return <section className={`${isCompact ? 'py-12 bg-cream/60' : 'py-20 bg-white'} border-y border-cream-dark`} aria-label="Patrocinantes y respaldo profesional" data-id="element-331">
      <div className="max-w-5xl mx-auto px-6" data-id="element-332">
        <FadeIn data-id="element-333">
          <div className="text-center mb-8" data-id="element-334">
            <span className="inline-block text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-accent mb-3" data-id="element-335">
              Con el respaldo de
            </span>
            {!isCompact && <h2 className="text-2xl md:text-4xl font-bold text-brown-dark mb-3" data-id="element-336">
                Nuestros patrocinantes
              </h2>}
            <p className="text-brown/70 font-serif max-w-2xl mx-auto" data-id="element-337">
              Profesionales y centros de salud que respaldan nuestro contenido.
            </p>
          </div>
        </FadeIn>

        <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${isCompact ? 'max-w-3xl' : 'max-w-4xl'} mx-auto`} data-id="element-338">
          {sponsors.map((sponsor, idx) => <FadeIn key={sponsor.name} delay={idx * 0.1} data-id="element-339">
              <a href={sponsor.instagramUrl} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-5 bg-white rounded-2xl p-5 md:p-6 border border-cream-dark hover:border-accent hover:shadow-soft transition-all duration-300 h-full" data-id="element-340">
                <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-xl bg-white border border-cream-dark flex items-center justify-center overflow-hidden p-2" data-id="element-341">
                  <img src={sponsor.logo} alt={`Logo de ${sponsor.name}`} className="max-w-full max-h-full object-contain" data-id="element-342" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-343">
                  <h3 className="font-bold text-brown-dark text-base md:text-lg leading-tight mb-1" data-id="element-344">
                    {sponsor.name}
                  </h3>
                  <p className="text-sm text-brown/70 mb-2" data-id="element-345">{sponsor.role}</p>
                  <div className="inline-flex items-center gap-1.5 text-accent text-sm font-medium group-hover:underline" data-id="element-346">
                    <Instagram className="w-4 h-4" data-id="element-347" />
                    <span data-id="element-348">{sponsor.instagram}</span>
                  </div>
                </div>
              </a>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}